import { useState, FocusEventHandler, useRef } from 'react'

const useFocusInterceptor = (): {
    isActionRequired: boolean
    interceptFocus: FocusEventHandler<HTMLInputElement>
    handleDecision: (value: boolean) => void
} => {
    const [isDecisionValid, setDecisionValid] = useState(false)
    const [isActionRequired, setIsActionRequired] = useState(false)
    const focussedElementRef = useRef<HTMLInputElement | null>(null)

    const interceptFocus: FocusEventHandler<HTMLInputElement> = (e) => {
        if (isDecisionValid) return
        focussedElementRef.current = document.activeElement as HTMLInputElement
        e.preventDefault()
        e.stopPropagation()
        setIsActionRequired(true)
    }

    const handleDecision = (value: boolean) => {
        if (value) {
            try {
                focussedElementRef.current?.focus()
            } catch (error) {
                console.log(`error while focussing element: ${JSON.stringify(error, null, 2)}`)
            }
        }
        setIsActionRequired(false)
        setDecisionValid(value)
    }

    return { isActionRequired, interceptFocus, handleDecision }
}

export default useFocusInterceptor
